<template>
    <div class="panel-body">

        <el-dialog title="容量系数" width="60%" :visible="capacityDialogVisible" @close="close" center>
            <el-row class="column-name" justify="start">
                <span>容量系数标准</span>
            </el-row>
            <el-table :data="tableData1" stripe style="width: 100%">
                <el-table-column prop="col1" style="" label="IT负载设计容量">
                </el-table-column>
                <el-table-column prop="val1" label="容量系数">
                </el-table-column>
            </el-table>

            <el-row class="column-name" justify="start">
                <span>各数据中心IT负载设计容量</span>
            </el-row>
            <el-table :data="tableData2" stripe style="width: 100%">
                <el-table-column prop="col1" style="" label="数据中心">
                </el-table-column>
                <el-table-column prop="val1" label="IT负载设计容量">
                </el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    import AthubCloudApi from "../../../api/athubCloud";
    import {getDeptItload} from "../assessment_common";
    import DomainalnApi from "@/api/domainaln";

    const deptNSHelper = createNamespacedHelpers("dept");

    export default {
        name: "capacity",

        data() {
            return {
                tableData1: [],

                tableData2: [],

            }
        },

        props: ['capacityDialogVisible'],

        methods: {

            close() {
                this.$emit('update:capacityDialogVisible', false);
            },

            getCapacityInfo() {
                this.tableData1 = [];
                DomainalnApi.list({domainid: "CAPACITYFOMULA"}).then(res => {
                    for (let i = 0; i < res.length; i++) {
                        res[i].value = res[i].value.replace(/\?/g, '').replace('&&', '-');
                        if (res[i].value.includes('-')) {
                            res[i].value = res[i].value.replace(/>/g, '').replace(/</g, '').replace(/=/g, '');
                            let tmpArr = res[i].value.split('-');
                            for (let j = 0; j < tmpArr.length; j++) {
                                tmpArr[j] = tmpArr[j] + 'KW';
                            }
                            res[i].value = tmpArr.join('-');
                        } else {
                            res[i].value = res[i].value + 'KW';
                        }
                        this.tableData1.push({
                            'col1': res[i].value,
                            'val1': res[i].description,
                        })
                    }
                });
            },

        },

        computed: {
            ...deptNSHelper.mapGetters(['deptSource$']),
        },

        mounted() {

            this.deptSource$.subscribe(v => {
                if (v != null && v.length > 0) {
                    this.tableData2 = v;

                    AthubCloudApi.fetchAllSysroomList().then(res => {
                        this.tableData2.forEach(e => {
                            e.col1 = e.name;
                            e.val1 = getDeptItload(res, e.id);
                        });
                    });
                }
            });

            this.getCapacityInfo();
        }

    }
</script>

<style scoped>

</style>